import React from 'react';

const renderResultAnswer = (result) => {
    const { type, options, answer_text, answer_number, answer_date, answer_datetime, matrix_answers } = result;
    
    switch (type) {
        case 'Opción múltiple: solo una respuesta':
            const selectedSingle = options?.find(option => option.selected);
            return (
                <div>
                    <span className="fw-bold">
                        {selectedSingle ? selectedSingle.description : 'Sin respuesta'}
                    </span>
                </div>
            );

        case 'Opción múltiple: se permiten varias respuestas':
            const selectedMultiple = options?.filter(option => option.selected) || [];
            return (
                <div>
                    <div className="fw-bold">
                        {selectedMultiple.length > 0 ? (
                            <ul className="mb-0">
                                {selectedMultiple.map((option, index) => (
                                    <li key={option.id || index}>{option.description}</li>
                                ))}
                            </ul>
                        ) : 'Sin respuesta'}
                    </div>
                </div>
            );

        case 'Cuadro de texto de una línea':
        case 'Cuadro de texto con varias líneas':
            return (
                <div>
                    <span className="fw-bold">
                        {answer_text ? `"${answer_text}"` : 'Sin respuesta'}
                    </span>
                </div>
            );

        case 'Valor numérico':
            return (
                <div>
                    <span className="fw-bold text-success">
                        {answer_number !== null && answer_number !== undefined ? parseInt(answer_number) : 'Sin respuesta'}
                    </span>
                </div>
            );

        case 'Fecha':
            return (
                <div>
                    <span className="fw-bold">
                        {answer_date ? new Date(answer_date).toLocaleDateString('es-ES', {
                            year: 'numeric',
                            month: 'long', 
                            day: 'numeric'
                        }) : 'Sin respuesta'}
                    </span>
                </div>
            );

        case 'Fecha y hora':
            return (
                <div>
                    <span className="fw-bold">
                        {answer_datetime ? new Date(answer_datetime).toLocaleString('es-ES', {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit',
                            hour12: false
                        }) : 'Sin respuesta'}
                    </span>
                </div>
            );

        case 'Matriz':
            if (matrix_answers && matrix_answers.length > 0) {
                const rows = options?.filter(option => option.type === 'Fila') || [];
                const columns = options?.filter(option => option.type === 'Columna') || [];
                
                return (
                    <div>
                        <div className="fw-bold">
                            {matrix_answers.map((matrixAnswer, index) => {
                                const row = rows.find(r => r.id === matrixAnswer.row_id);
                                const column = columns.find(c => c.id === matrixAnswer.column_id);
                                return (
                                    <div key={index} className="mb-1">
                                        <strong>{row?.description}:</strong> {column?.description}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                );
            }
            return (
                <div>
                    <span className="text-muted fst-italic">Sin respuestas en matriz</span>
                </div>
            );

        default:
            return (
                <div>
                    <span className="text-muted">Tipo de pregunta no reconocido: {type}</span>
                </div>
            );
    }
};

export const renderAnswerValue = (userAnswer, questionType, answers) => {
    
    if (typeof userAnswer === 'object' && userAnswer !== null && 
        (userAnswer.hasOwnProperty('question_id') || userAnswer.hasOwnProperty('type'))) {
        return renderResultAnswer(userAnswer);
    }
    
    if (typeof userAnswer === 'object' && userAnswer !== null && !Array.isArray(userAnswer)) {
        const question = userAnswer;
        const userAnswers = questionType || [];
        const questionTypeFromObject = question.questionType;
        
        switch (questionTypeFromObject) {
            case 'Opción múltiple: solo una respuesta':
            case 'Opción múltiple: se permiten varias respuestas':
                const selectedAnswers = question.answers?.filter(answer => 
                    userAnswers.some(userAnswer => userAnswer.answer_id === answer.id)
                ) || [];
                
                return selectedAnswers.length > 0 
                    ? selectedAnswers.map(answer => answer.description).join(', ')
                    : 'Sin respuesta';
                
            case 'Cuadro de texto con varias líneas':
            case 'Cuadro de texto de una línea':
                const textAnswer = userAnswers.find(ua => ua.question_id === question.id);
                return textAnswer?.answer_text || 'Sin respuesta';
                
            case 'Valor numérico':
                const numAnswer = userAnswers.find(ua => ua.question_id === question.id);
                return numAnswer?.answer_number !== null && numAnswer?.answer_number !== undefined 
                    ? numAnswer.answer_number.toString() 
                    : 'Sin respuesta';
                
            case 'Fecha':
                const dateAnswer = userAnswers.find(ua => ua.question_id === question.id);
                return dateAnswer?.answer_date ? formatDate(dateAnswer.answer_date) : 'Sin respuesta';
                
            case 'Fecha y hora':
                const datetimeAnswer = userAnswers.find(ua => ua.question_id === question.id);
                return datetimeAnswer?.answer_datetime 
                    ? formatDateTime(datetimeAnswer.answer_datetime)
                    : 'Sin respuesta';
                
            case 'Matriz':
                const matrixAnswers = userAnswers.filter(ua => 
                    ua.question_id === question.id && ua.matrix_answer
                );
                
                if (matrixAnswers.length > 0) {
                    return matrixAnswers.map(answer => {
                        const row = question.answers?.find(ans => ans.id === answer.matrix_answer.row_id && ans.type === 'Fila');
                        const col = question.answers?.find(ans => ans.id === answer.matrix_answer.column_id && ans.type === 'Columna');
                        return `${row?.description}: ${col?.description}`;
                    }).join(', ');
                }
                return 'Sin respuesta';
                
            default:
                return 'Tipo de respuesta no reconocido';
        }
    }
    
    if (!userAnswer && userAnswer !== 0) {
        return (
            <span className="text-muted fst-italic">
                Sin respuesta
            </span>
        );
    }

    switch (questionType) {
        case 'TEXTO':
        case 'TEXT':
            return (
                <div>
                    <span className="fw-bold">{String(userAnswer)}</span>
                </div>
            );

        case 'NUMERO':
        case 'NUMBER':
            return (
                <div>
                    <span className="fw-bold text-success">{String(userAnswer)}</span>
                </div>
            );

        case 'OPCION_MULTIPLE':
        case 'MULTIPLE_CHOICE':
        case 'LISTA':
        case 'LIST':
            if (answers && Array.isArray(answers)) {
                const selectedAnswer = answers.find(answer => 
                    String(answer.answer_id) === String(userAnswer) || 
                    String(answer.answer_text) === String(userAnswer)
                );
                
                return (
                    <div>
                        <span className="fw-bold">
                            {selectedAnswer ? selectedAnswer.answer_text : String(userAnswer)}
                        </span>
                    </div>
                );
            }
            
            return (
                <div>
                    <span className="fw-bold">{String(userAnswer)}</span>
                </div>
            );

        case 'FECHA':
        case 'DATE':
            const dateValue = new Date(userAnswer);
            const isValidDate = !isNaN(dateValue.getTime());
            
            return (
                <div>
                    <span className="fw-bold">
                        {isValidDate ? dateValue.toLocaleDateString() : String(userAnswer)}
                    </span>
                </div>
            );

        case 'BOOLEAN':
        case 'SI_NO':
            const boolValue = String(userAnswer).toLowerCase();
            const isTrue = boolValue === 'true' || boolValue === 'si' || boolValue === 'sí' || boolValue === '1';
            
            return (
                <div>
                    <span className="fw-bold">
                        {isTrue ? 'Sí' : 'No'}
                    </span>
                </div>
            );

        default:
            return (
                <div>
                    <span className="fw-bold">{String(userAnswer)}</span>
                </div>
            );
    }
};

export const getAnswerTypeColor = (questionType) => {
    switch (questionType) {
        case 'Opción múltiple: solo una respuesta':
            return 'primary';
        case 'Opción múltiple: se permiten varias respuestas':
            return 'success';
        case 'Cuadro de texto con varias líneas':
        case 'Cuadro de texto de una línea':
            return 'warning';
        case 'Valor numérico':
            return 'info';
        case 'Fecha':
        case 'Fecha y hora':
            return 'secondary';
        case 'Matriz':
            return 'dark';
        default:
            return 'light';
    }
};

const formatDate = (dateString) => {
    try {
        return new Date(dateString).toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    } catch (error) {
        return dateString;
    }
};

const formatDateTime = (dateTimeString) => {
    try {
        return new Date(dateTimeString).toLocaleString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    } catch (error) {
        return dateTimeString;
    }
};

export const countResponseTypes = (results) => {
    if (!results || results.length === 0) return {};
    
    return results.reduce((acc, result) => {
        const type = result.type;
        acc[type] = (acc[type] || 0) + 1;
        return acc;
    }, {});
};

export const getSurveyStatistics = (surveyData, userAnswers = []) => {
    if (!surveyData || !surveyData.questions || surveyData.questions.length === 0) {
        return {
            totalQuestions: 0,
            answeredQuestions: 0,
            unansweredQuestions: 0,
            completionPercentage: 0
        };
    }

    const totalQuestions = surveyData.questions.length;
    const answeredQuestions = surveyData.questions.filter(question => {
        const hasAnswer = userAnswers.some(answer => answer.question_id === question.id);
        return hasAnswer;
    }).length;

    const unansweredQuestions = totalQuestions - answeredQuestions;
    const completionPercentage = totalQuestions > 0 ? 
        Math.round((answeredQuestions / totalQuestions) * 100) : 0;

    return {
        totalQuestions,
        answeredQuestions,
        unansweredQuestions,
        completionPercentage
    };
};

export const getSurveyInfo = (surveyData) => {
    if (!surveyData) return null;
    
    return {
        id: surveyData.id,
        name: surveyData.name,
        description: surveyData.description,
        surveyType: surveyData.survey_type,
        finalMessage: surveyData.finalMessage,
        totalScore: surveyData.total_score,
        surveyUserId: surveyData.surveyuser_id
    };
};